export const USER_ONLINE_DRAWER_WIDTH = 'USER_ONLINE_DRAWER_WIDTH';
export const USER_ONLINE_MINI_DRAWER_WIDTH = 'USER_ONLINE_MINI_DRAWER_WIDTH';
